module.exports = __webpack_public_path__ + "img/chocolate-ball.af99611b.png";